import {
  Text,
  MenuItem,
  MenuItemProps,
  AvatarProps,
  VStack,
  useColorModeValue,
} from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { ANONYMOUS_USER_ICON, ANONYMOUS_PENDING_ICON } from './constants';
import { MentionUserAvatar } from './MentionUserAvatar';

export const MentionListItem = ({
  src = ANONYMOUS_USER_ICON,
  srcSet,
  email,
  name,
  isPending,
  avatarSize,
  ...menuItemProps
}: {
  isSelected?: boolean;
  src?: AvatarProps['src'];
  srcSet?: AvatarProps['srcSet'];
  avatarSize: AvatarProps['size'];
  email?: string;
  name?: string;
  isPending?: boolean;
} & MenuItemProps) => {
  const textColor = useColorModeValue('#47515B', '#B5B5B5');

  return (
    <MenuItem py={8} {...menuItemProps} gap="2" minW="0">
      <MentionUserAvatar
        size={avatarSize}
        srcSet={isPending ? ANONYMOUS_PENDING_ICON : srcSet}
        src={isPending ? ANONYMOUS_PENDING_ICON : src}
        alt="avatar"
        nameProps={{ name: name ?? '' }}
      />
      <VStack alignItems="flex-start" gap="0" minW="0">
        {name ? (
          <Text
            variant="body-xl"
            fontSize="text-sm"
            fontWeight="bold"
            as="label"
            color="text-primary"
            w="100%"
            isTruncated
          >
            {name}
          </Text>
        ) : null}
        {/* when there is a team user instance, or pending user - we receive email from api */}
        {email ? (
          <Text
            variant="body-xl"
            fontSize={isPending ? 'text-sm' : 'text-xs'}
            fontWeight={isPending ? 'bold' : 'regular'}
            color={isPending ? 'text-primary' : textColor}
            w="100%"
            isTruncated
          >
            {email}
          </Text>
        ) : null}
        {isPending ? (
          <Text variant="body-xl" fontSize="text-xs" color={textColor} as="i">
            {translate('Pending')}
          </Text>
        ) : null}
      </VStack>
    </MenuItem>
  );
};
